const betaURL = require("app/util/config/beta-url");
const CardWithLoader = require("../Dashboard/card-with-loader");
const Summary = require("../Dashboard/summary");
const Chart = require("../Dashboard/Chart/chart");
const DetailsLink = require("./details-link");

const Reflux = require("reflux");
const WonDealsStore = require("../../stores/won-deals-store");
const WonDealsActions = require("../../actions/won-deals-actions");

const moment = require("moment");
const currencyFormatter = require("app/util/formatter/currency");
const dateFormatter = require("app/util/formatter/date");
const deltaCalculator = require("./util/delta-type");

const AnimatedValue = require("app/shared/components/AnimatedValue/animated-value");

const WonDealsWidget = React.createClass({
  mixins: [Reflux.ListenerMixin],

  getInitialState: function() {
    return WonDealsStore.getInitialState();
  },

  componentDidMount: function() {
    this.listenTo(WonDealsStore, this.setState);
    this.refresh();
  },

  componentDidUpdate: function(prevProps) {
    if (prevProps != this.props) {
      this.refresh();
    }
  },

  refresh: function() {
    WonDealsActions.fetchData(
      this.props.period,
      this.props.comparison,
      this.props.users,
      this.props.funnel
    );
  },

  getDetailsUrl: function() {
    let dateFormat = "YYYY-MM-DD";
    let formattedStartDate = this.props.period.startDate.format(dateFormat);
    let formattedEndDate = this.props.period.endDate.format(dateFormat);

    let searchParams = new URLSearchParams();

    searchParams.append("sn", 2);
    searchParams.append("dci", formattedStartDate);
    searchParams.append("dcf", formattedEndDate);
    searchParams.append("qpp", 25);

    if (this.props.selectedUser)
      searchParams.append("ur", this.props.selectedUser);
    if (this.props.selectedTeam)
      searchParams.append("team", this.props.selectedTeam);
    if (this.props.funnel)
      searchParams.append("funil", this.props.funnel);

    return `${betaURL()}/deals?${searchParams}`;
  },

  deltaTooltipText: function(value, transform) {
    const comparisonStart = this.props.comparison.startDate.format("DD MMM, YYYY");
    const comparisonEnd = this.props.comparison.endDate.format("DD MMM, YYYY");
    const comparison = `${comparisonStart} - ${comparisonEnd}`;

    if (value === 0) {
      return `Sem mudanças em relação a ${comparison}`;
    }

    const noun = value > 0 ? "Aumento" : "Diminuição";

    return `${noun} de <b>${transform(Math.abs(value))}</b> comparado com ${comparison}`;
  },

  tooltipText: function(value, label) {
    const periodStart = this.props.period.startDate.format("DD MMM, YYYY");
    const periodEnd = this.props.period.endDate.format("DD MMM, YYYY");
    const periodText = `${periodStart} - ${periodEnd}`;

    return `<b>${value}</b>${label ? ' ' + label : ''} em ${periodText}`;
  },

  animatedValue: function(value, formatter = undefined) {
    return <AnimatedValue value={value} formatter={formatter} />;
  },

  render: function() {
    return (
      <CardWithLoader
        loading={this.state.loading}
        failed={this.state.failed}
        onRetry={this.refresh}
        title={
          <p>Negócios ganhos</p>
        }
        className="grid-item-col-2 grid-item-row-2"
        footer={<DetailsLink url={this.getDetailsUrl()} />}
      >
        <div className="d-g grid-2 gg-20">
          <Summary
            big
            value={this.animatedValue(this.state.data.count)}
            tooltipText={this.tooltipText(this.state.data.count, "negócios ganhos")}
            delta={this.animatedValue(this.state.data.countDelta)}
            url={this.getDetailsUrl()}
            deltaTooltipText={this.deltaTooltipText(this.state.data.countDelta, (value) => { return `${value} negócios ganhos` })}
            deltaType={deltaCalculator.deltaType(this.state.data.countDelta)}
          />

          <Summary
            title="Valor em vendas"
            url={this.getDetailsUrl()}
            value={this.animatedValue(this.state.data.amount, currencyFormatter.formatCentsToCurrency)}
            tooltipText={this.tooltipText("Valor total em vendas")}
            delta={this.animatedValue(this.state.data.amountDelta, currencyFormatter.formatCentsToCurrency)}
            deltaTooltipText={this.deltaTooltipText(this.state.data.amountDelta, currencyFormatter.formatCentsToCurrency)}
            deltaType={deltaCalculator.deltaType(this.state.data.amountDelta)}
          />

          <Summary
            title="Ciclo médio de vendas"
            url={this.getDetailsUrl()}
            value={this.animatedValue(this.state.data.averageDuration, dateFormatter.formatNumberToDays)}
            delta={this.animatedValue(this.state.data.averageDurationDelta, dateFormatter.formatNumberToDays)}
            deltaTooltipText={this.deltaTooltipText(this.state.data.averageDurationDelta, dateFormatter.formatNumberToDays)}
            deltaType={deltaCalculator.reverseDeltaType(this.state.data.averageDurationDelta)}
          />

          <Summary
            title="Ticket médio"
            url={this.getDetailsUrl()}
            value={this.animatedValue(this.state.data.averageAmount, currencyFormatter.formatCentsToCurrency)}
            delta={this.animatedValue(this.state.data.averageAmountDelta, currencyFormatter.formatCentsToCurrency)}
            deltaTooltipText={this.deltaTooltipText(this.state.data.averageAmountDelta, currencyFormatter.formatCentsToCurrency)}
            deltaType={deltaCalculator.deltaType(this.state.data.averageAmountDelta)}
          />

          <div className="grid-item-col-2 mt-20">
            <Chart
              type="line"
              datasets={[{
                data: this.state.data.history.map(item => (
                  { x: item.date, y: item.total_amount }
                )),
                borderColor: "#5dcfc8",
                backgroundColor: "#5dcfc8"
              }]}
              options={{
                aspectRatio: 1.6,
                legend: false,
                scales: {
                  xAxes: [{
                    type: "time",
                    time: {
                      unit: "month",
                      tooltipFormat: "MMMM/YYYY"
                    }
                  }],
                  yAxes: [{
                    ticks: {
                      suggestedMax: 1000,
                      callback: currencyFormatter.formatCentsToAbbreviatedCurrency
                    }
                  }]
                },
                tooltips: {
                  callbacks: {
                    label: (tooltipItem, data) => {
                      let count = this.state.data.history[tooltipItem.index].count;
                      let formattedValue = currencyFormatter.formatCentsToCurrency(tooltipItem.yLabel);

                      return [
                        formattedValue,
                        `${count} negócios ganhos`
                      ];
                    }
                  }
                }
              }}
            />
          </div>
        </div>
      </CardWithLoader>
    )
  }
});

module.exports = WonDealsWidget;



// WEBPACK FOOTER //
// ./app/screens/Dashboard/components/Widgets/won-deals-widget.jsx